import { render, staticRenderFns } from "./ownerVotingList.vue?vue&type=template&id=620b6fa0&scoped=true"
import script from "./ownerVotingList.vue?vue&type=script&lang=js"
export * from "./ownerVotingList.vue?vue&type=script&lang=js"
import style0 from "./ownerVotingList.vue?vue&type=style&index=0&id=620b6fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b6fa0",
  null
  
)

export default component.exports